import IconCopySolid from '@/assets/icons/font_awesome/copy-solid.svg?react';
import { UI_PRIMITIVE__icon_animated } from '@/components/ui/UI_PRIMITIVE__icon_animated';
import { UI_PRIMITIVE__input } from '@/components/ui/UI_PRIMITIVE__input';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function InputWorkspaceInviteLink() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { toast } = useToast();

  const { workspace_current, invitations_map_to_other_users } = use_slice_workspace(['workspace_current', 'invitations_map_to_other_users']);

  const [isHovered, setIsHovered] = useState(false);

  async function onClick() {
    await navigator.clipboard.writeText(get_workspace_invitation_link());

    toast({ title: t(i18n_base_ui.toasts.input_worspace_invite_link_copy_button.title) });
  }

  function get_workspace_invitation_link() {
    let invitations_array = Array.from(invitations_map_to_other_users.values());

    let invitation_by_link = invitations_array.find_or_assert(
      item => item.workspace_id == workspace_current._id && item.target_user_email == CONSTANTS__shared.TOKEN_WORKSPACE_INVITATION_LINK_EMAIL,
      { context: 'invitation_by_link', workspace_id: workspace_current._id },
    );

    return ENUM__page_type.BUILD_FULL_PATH_WORKSPACE_INVITATION(invitation_by_link.token);
  }

  return (
    <UI_PRIMITIVE__input
      {...{ onClick }}
      wrapperClassName={`${md('', '!w-[30rem]')}`}
      className={`cursor-pointer bg-component border border-component-border focus:outline-none   ${
        workspace_current.invite_by_link_enabled ? '' : 'opacity-50 cursor-not-allowed'
      }`}
      readOnly
      disabled={!workspace_current.invite_by_link_enabled}
      iconEnd={
        <UI_PRIMITIVE__icon_animated
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          {...{ onClick }}
          className={`!w-5 !h-5 ${isHovered ? '!text-bar-foreground' : '!text-component-item-foreground'}`}
          Icon={IconCopySolid}
          renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        />
      }
      value={get_workspace_invitation_link()}
    />
  );
}
